import React from 'react';
import Images from '../../img';
import Utils from './utils'

class InlineSvg extends React.Component {

  render() {
    return <span className="inline-svg">{Utils.toHTML(Images[this.props.src])}</span>
  }

}

export default InlineSvg;
